import { SET_FACTION_FILTERS } from '../actions/actionTypes';

const initialState = {};

export const factionFiltersReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_FACTION_FILTERS:
            return { ...state, [action.data.faccaoKey]: { ...state[action.data.faccaoKey], ...action.data.data } };
        default:
            return state;
    }
};
